import Model from '@/lib/data/Model';
import RiskSection from './RiskSection';
import Survey from './Survey';

class Risk extends Model {
    fields = [
        {
            name: 'total_rank',
            type: 'float',
            defaultValue: 0,
            getter(v) {
                return Math.floor(v * 10000) / 100;
            },
        },
        {
            name: 'sections',
            association: {
                type: 'many',
                model: RiskSection,
            },
        },
        {
            name: 'surveys',
            association: {
                type: 'many',
                model: Survey,
            },
        },
    ];

    /**
     * Create the Risk object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'getSections',
            url: '/risk/sections',
            params: ['visit_id'],
        },
        {
            name: 'getSurveyDetail',
            url: '/risk/surveydetail',
            params: ['visit_id'],
        },
    ];
}

export default Risk;
